/* eslint-disable i18n/no-russian-character */

import { DadataAddress, ResponseMap } from '@/fo/api/dadata';

export type Suggestion = {
  id: string;
  fiasId: string;
  value: string;
  postcode: string;
  countryCode: string;
  regionCode: string;
  geoLat: string;
  geoLon: string;
  region: string;
  cityPure: string;
};

export const INITIAL_CITIES: Suggestion[] = [
  {
    id: '7700000000000',
    fiasId: '0c5b2444-70a0-4932-980c-b4dc0d3f02b5',
    value: 'Москва',
    postcode: '101000',
    countryCode: 'RU',
    regionCode: 'RU-MOW',
    geoLon: '37.620393',
    geoLat: '55.75396',
    region: 'Москва',
    cityPure: 'Москва'
  },
  {
    id: '7800000000000',
    fiasId: 'c2deb16a-0330-4f05-821f-1d09c93331e6',
    value: 'Санкт-Петербург',
    postcode: '190000',
    countryCode: 'RU',
    regionCode: 'RU-SPE',
    geoLon: '30.315879',
    geoLat: '59.939084',
    region: 'Санкт-Петербург',
    cityPure: 'Санкт-Петербург'
  },
  {
    id: '6600000100000',
    fiasId: '2763c110-cb8b-416a-9dac-ad28a55b4402',
    value: 'Екатеринбург',
    postcode: '620000',
    countryCode: 'RU',
    regionCode: 'RU-SVE',
    geoLon: '60.605514',
    geoLat: '56.838607',
    region: 'Свердловская',
    cityPure: 'Екатеринбург'
  },
  {
    id: '5200000100000',
    fiasId: '555e7d61-d9a7-4ba6-9770-6caa8198c483',
    value: 'Нижний Новгород',
    postcode: '603000',
    countryCode: 'RU',
    regionCode: 'RU-NIZ',
    geoLon: '44.006495',
    geoLat: '56.326794',
    region: 'Нижегородская',
    cityPure: 'Нижний Новгород'
  },
  {
    id: '2300000100000',
    fiasId: '7dfa745e-aa19-4688-b121-b655c11e482f',
    value: 'Краснодар',
    postcode: '350000',
    countryCode: 'RU',
    regionCode: 'RU-KDA',
    geoLon: '38.975301',
    geoLat: '45.035453',
    region: 'Краснодарский',
    cityPure: 'Краснодар'
  },
  {
    id: '6300000100000',
    fiasId: 'bb035cc3-1dc2-4627-9d25-a1bf2d4b936b',
    value: 'Самара',
    postcode: '443000',
    countryCode: 'RU',
    regionCode: 'RU-SAM',
    geoLon: '50.106868',
    geoLat: '53.195096',
    region: 'Самарская',
    cityPure: 'Самара'
  },
  {
    id: '5400000100000',
    fiasId: '8dea00e3-9aab-4d8e-887c-ef2aaa546456',
    value: 'Новосибирск',
    postcode: '630000',
    countryCode: 'RU',
    regionCode: 'RU-NVS',
    geoLon: '82.920426',
    geoLat: '55.030187',
    region: 'Новосибирская',
    cityPure: 'Новосибирск'
  },
  {
    id: '1600000100000',
    fiasId: '93b3df57-4c89-44df-ac42-96f05e9cd3b9',
    value: 'Казань',
    postcode: '420000',
    countryCode: 'RU',
    regionCode: 'RU-TA',
    geoLon: '49.111451',
    geoLat: '55.794438',
    region: 'Татарстан',
    cityPure: 'Казань'
  },
  {
    id: '7400000100000',
    fiasId: 'a376e68d-724a-4472-be7c-891bdb09ae32',
    value: 'Челябинск',
    postcode: '454000',
    countryCode: 'RU',
    regionCode: 'RU-CHE',
    geoLon: '61.400856',
    geoLat: '55.160283',
    region: 'Челябинская',
    cityPure: 'Челябинск'
  },
  {
    id: '3800000100000',
    fiasId: '8eeed222-72e7-47c3-ab3a-9a553c31cf72',
    value: 'Иркутск',
    postcode: '664000',
    countryCode: 'RU',
    regionCode: 'RU-IRK',
    geoLon: '104.28066',
    geoLat: '52.286387',
    region: 'Иркутская',
    cityPure: 'Иркутск'
  },
  {
    id: '0200000100000',
    fiasId: '7339e834-2cb4-4734-a4c7-1fca2c66e562',
    value: 'Уфа',
    postcode: '450000',
    countryCode: 'RU',
    regionCode: 'RU-BA',
    geoLon: '55.957856',
    geoLat: '54.734856',
    region: 'Башкортостан',
    cityPure: 'Уфа'
  },
  {
    id: '2400000100000',
    fiasId: '9b968c73-f4d4-4012-8da8-3dacd4d4c1bd',
    value: 'Красноярск',
    postcode: '660000',
    countryCode: 'RU',
    regionCode: 'RU-KYA',
    geoLon: '92.852449',
    geoLat: '56.009477',
    region: 'Красноярский',
    cityPure: 'Красноярск'
  },
  {
    id: '6100000100000',
    fiasId: 'c1cfe4b9-f7c2-423c-abfa-6ed1c05a15c5',
    value: 'Ростов-на-Дону',
    postcode: '344000',
    countryCode: 'RU',
    regionCode: 'RU-ROS',
    geoLon: '39.718705',
    geoLat: '47.222531',
    region: 'Ростовская',
    cityPure: 'Ростов-на-Дону'
  },
  {
    id: '7600000100000',
    fiasId: '6b1bab7d-ee45-4168-a2a6-4ce2880d90d3',
    value: 'Ярославль',
    postcode: '150000',
    countryCode: 'RU',
    regionCode: 'RU-YAR',
    geoLon: '39.897822',
    geoLat: '57.621562',
    region: 'Ярославская',
    cityPure: 'Ярославль'
  },
  {
    id: '2500000100000',
    fiasId: '7b6de6a5-86d0-4735-b11a-499081111af8',
    value: 'Владивосток',
    postcode: '690000',
    countryCode: 'RU',
    regionCode: 'RU-PRI',
    geoLon: '131.882421',
    geoLat: '43.116391',
    region: 'Приморский',
    cityPure: 'Владивосток'
  },
  {
    id: '7100000100000',
    fiasId: 'b2601b18-6da2-4789-9fbe-800dde06a2bb',
    value: 'Тула',
    postcode: '300000',
    countryCode: 'RU',
    regionCode: 'RU-TUL',
    geoLon: '37.615349',
    geoLat: '54.191982',
    region: 'Тульская',
    cityPure: 'Тула'
  },
  {
    id: '6400000100000',
    fiasId: 'bf465fda-7834-47d5-986b-ccdb584a85a6',
    value: 'Саратов',
    postcode: '410000',
    countryCode: 'RU',
    regionCode: 'RU-SAR',
    geoLon: '46.034257',
    geoLat: '51.533557',
    region: 'Саратовская',
    cityPure: 'Саратов'
  },
  {
    id: '5900000100000',
    fiasId: 'a309e4ce-2f36-4106-b1ca-53e0f48a6d95',
    value: 'Пермь',
    postcode: '614000',
    countryCode: 'RU',
    regionCode: 'RU-PER',
    geoLon: '56.234195',
    geoLat: '58.010259',
    region: 'Пермский',
    cityPure: 'Пермь'
  },
  {
    id: '7200000100000',
    fiasId: '9ae64229-9f7b-4149-b27a-d1f6ec74b5ce',
    value: 'Тюмень',
    postcode: '625000',
    countryCode: 'RU',
    regionCode: 'RU-TYU',
    geoLon: '65.534328',
    geoLat: '57.153033',
    region: 'Тюменская',
    cityPure: 'Тюмень'
  },
  {
    id: '5500000100000',
    fiasId: '140e31da-27bf-4519-9ea0-6185d681d44e',
    value: 'Омск',
    postcode: '644000',
    countryCode: 'RU',
    regionCode: 'RU-OMS',
    geoLon: '73.367525',
    geoLat: '54.984912',
    region: 'Омская',
    cityPure: 'Омск'
  },
  {
    id: '3600000100000',
    fiasId: '5bf5ddff-6353-4a3d-80c4-6fb27f00c6c1',
    value: 'Воронеж',
    postcode: '394000',
    countryCode: 'RU',
    regionCode: 'RU-VOR',
    geoLon: '39.196854',
    geoLat: '51.659306',
    region: 'Воронежская',
    cityPure: 'Воронеж'
  },
  {
    id: '3400000100000',
    fiasId: 'a52b7389-0cfe-46fb-ae15-298652a64cf8',
    value: 'Волгоград',
    postcode: '400066',
    countryCode: 'RU',
    regionCode: 'RU-VGG',
    geoLon: '44.516939',
    geoLat: '48.707103',
    region: 'Волгоградская',
    cityPure: 'Волгоград'
  },
  {
    id: '2300000700000',
    fiasId: '79da737a-603b-4c19-9b54-9114c96fb912',
    value: 'Сочи',
    postcode: '354000',
    countryCode: 'RU',
    regionCode: 'RU-KDA',
    geoLon: '39.723062',
    geoLat: '43.585525',
    region: 'Краснодарский',
    cityPure: 'Сочи'
  },
  {
    id: '2700000100000',
    fiasId: 'a4859da8-9977-4b62-8436-4e1b98c5d13f',
    value: 'Хабаровск',
    postcode: '680000',
    countryCode: 'RU',
    regionCode: 'RU-KHA',
    geoLon: '135.0598606',
    geoLat: '48.4648055',
    region: 'Хабаровский',
    cityPure: 'Хабаровск'
  }
];

const join = (arr: (string | null | undefined)[], separator = ', ') => {
  return arr.filter(Boolean).join(separator);
};

const cityToString = (address: DadataAddress) => {
  // fias_level см. https://dadata.ru/api/find-address/
  const isCity = ['4', '1'].includes(address.fias_level);

  return join([
    join([!isCity ? address.region_with_type : null], ' '),
    join([isCity ? null : address.city_type, address.city], ' '),
    join([address.settlement_type, address.settlement], ' ')
  ]);
};

export const removeNonCity = (
  suggestions: ResponseMap['addressSuggestion']['data']['suggestions']
) => {
  return suggestions.filter(
    // fias_level см. https://dadata.ru/api/find-address/
    (suggestion) => !['65', '5'].includes(suggestion.data.fias_level)
  );
};

export const mapCitiesFromDadata = (
  dadata: ResponseMap['addressSuggestion']['data']['suggestions']
): Suggestion[] => {
  return dadata
    .map((item) => ({
      id: item.data.kladr_id || '',
      fiasId:
        item.data.city_fias_id ||
        item.data.settlement_fias_id ||
        item.data.fias_id ||
        '',
      value: cityToString(item.data),
      postcode: item.data.postal_code || '',
      countryCode: item.data.country_iso_code,
      regionCode: item.data.region_iso_code,
      geoLon: item.data.geo_lon,
      geoLat: item.data.geo_lat,
      region: item.data.region,
      cityPure: join([
        item.data.city,
        join([item.data.settlement_type, item.data.settlement], ' ')
      ])
    }))
    .filter((item) => Boolean(item.value));
};
